<template>
  <div class="list-panel">
    <div v-loading="submitLoading" 
         element-loading-text="提交中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(255, 255, 255, 0.7)">
      <el-card class="box-card form-card">
        <div class="media_type-list">
          <div class="label">平台类型</div>
          <div class="con">
            <el-radio-group v-model="mediaType" size="small">
              <el-radio-button 
                v-for="(label, value) in mediaConfig.getConfigList('media_ch')"
                :key="value"
                :label="parseInt(value)"
              >{{ label }}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </el-card>
      <!-- 基础信息 -->
      <el-card class="box-card form-card">
        <form-basic ref="basicFormCon" :media-type="mediaType" :operate-type="'add'"></form-basic>
      </el-card>
      <!-- 价格信息 -->
      <!--
      <el-card class="box-card form-card">
        <form-price ref="priceFormCon" :price-list="[]" :media-type="this.mediaType"></form-price>
      </el-card>
      -->
      <!-- 商务信息 -->
      <el-card class="box-card form-card">
        <form-business ref="busiFormCon" :media-type="this.mediaType"></form-business>
      </el-card>
      <!-- 提交 -->
      <div class="submit-wrap">
        <el-button type="primary" @click="validForm" :disabled="submitLoading">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mediaConfig } from "@/const/config/media";
import formBasic from "./component/form-basic";
import formPrice from "./component/form-price";
import formBusiness from "./component/form-business";
import formFields from "@/const/media/formFields";
import util from "@/util/util"
import { addMedia } from "@/api/media/index";
export default {
  components: {
    formBasic,
    //formPrice,
    formBusiness
  },
  created() {
    
  },
  data () {
    return {
      mediaConfig: mediaConfig,
      mediaType: 1,
      submitLoading: false,

      categoryList: [],
      areaList: []
    }
  },
  methods: {
    // 校验表单
    validForm() {
      let r = true;
      let that = this;
      // 基础信息
      const p1 = new Promise((resolve, reject) => {
        that.$refs.basicFormCon.$refs['basicForm'].validate((valid, obj) => {
          if (valid) resolve()
          else reject({type: 1, errors: Object.keys(obj)})
        })
      })
      // 价格信息
      // const p2 = new Promise((resolve, reject) => {
      //   that.$refs.priceFormCon.$refs['priceForm'].validate((valid, obj) => {
      //     if (valid) resolve()
      //     else reject({type: 1, errors: ["price"]})
      //   })
      // })
      // 商务信息
      const p3 = new Promise((resolve, reject) => {
        that.$refs.busiFormCon.$refs['bussinessForm'].validate((valid, obj) => {
          if (valid) resolve()
          else reject({type: 1, errors: ["business"]})
        })
      })
      Promise.all([p1, p3]).then(() => {
        this.$nextTick(() => {
          let basic = that.$refs.basicFormCon.$refs['basicForm'].model;
          // let priceList = that.$refs.priceFormCon.$refs['priceForm'].model.mediaPriceList;
          let businessList = that.$refs.busiFormCon.$refs['bussinessForm'].model.mediaBusinessInfos;

          let obj = util.deepClone(basic);
          // obj.mediaPriceList = priceList;
          obj.mediaBusinessInfos = businessList;
          if (obj.areaId instanceof Array) {
            obj.areaId = obj.areaId.join(',');
          }
          if (obj.areaId == 'NaN') {
            obj.areaId = '';
          }

          this.submitForm(obj)

        })
      }).catch(error => {
        let errorChs = error.errors.map(v => '“' + (formFields.list[v] || '') + '"')
        if (error.type === 2) {
          this.$message.error(`表单不完整！`);
        } else {
          this.$message.error(`表单不完整！请检查${errorChs}等字段是否正确填写`);
        }
      });
    },
    /**
     * 新增
     * @param form 新增表单
     */
    submitForm(form) {
      this.submitLoading = true;
      form.mediaType = this.mediaType;
      addMedia(this.mediaType, form)
        .then(res => {
          let mtt_ch = mediaConfig.getAppointed("media_ch", this.mediaType);
          let mtt_en = mediaConfig.getAppointed("media_en", this.mediaType);
          this.$message.success(`${mtt_ch}新增成功`);
          this.submitLoading = false;
          setTimeout(() => {
            this.$router.push({ path: `/media/${mtt_en}` });
          }, 500)
        })
        .catch(err => {
          this.submitLoading = false;
        })
    }
  },
}
</script>

<style lang="scss" scoped>
.media_type-list {
  display: flex;
  align-items: center;
  .label {
    margin-right: 15px;
    font-size: 14px;
    font-weight: bold;
  }
}
.form-card {
  margin-bottom: 10px;
}
.submit-wrap {
  text-align: center;
  margin-top: 20px;
}
</style>